/**
 * The module's name, its route and the right that opens it — declared once.
 *
 * Renaming it must stay a ten-minute job, so nothing anywhere else may spell the label or
 * the path out again. Files, the API and the right still say "queries"; only what staff see
 * is "ADS Buki".
 */

export const QUERIES_LABEL = 'ADS Buki'

export const QUERIES_PATH = '/ads-buki'

/** The address before the rename. It redirects, so bookmarks still land on the page. */
export const OLD_QUERIES_PATH = '/queries'

/**
 * The same right `BookieChatGate` enforces on api/buki (`user.AdsBuki`, the "ADS Buki" tick on
 * the Windows user form). It is read out of `auth.permissions.VisibleTabs` exactly as every
 * other section reads its own key, so the page a staffer can open and the endpoint they can
 * call cannot disagree.
 */
export const QUERIES_PERMISSION = 'AdsBuki'
